import {FullGameFetchHandler} from "../../../core/handlers/full-game.fetch-handler";
import {LINEUPS} from "../../lineups-widget/lineups-widget.consts";
import {BoxScoresWidgetState} from "../models/box-scores-widget.state";

export class BoxScoresWidgetFetchHandler extends FullGameFetchHandler {
  state: BoxScoresWidgetState;

  async action() {
    await super.action()

    this.state.appState.appLineupsDisplayModel.isBoxScoresVisible = true;
    this.state.isHomeTeamSelected = true;
    this.controller.action(LINEUPS.ACTION_TYPES.lineupsDisplayHandler)
  }
}
